<template>
<section
  class="layout-main"
  :style="`padding-top:${showSideNav ? 78 : 32}px;padding-left:${sideBarWidth}px`"
  @mousedown="onWrapperMouseDown"
  @mouseup="onWrapperMouseUp"
>
  <layout-header :show-header="showSideNav" nav-line-height="32px" :style="{
    height: `${showSideNav ? 78 : 32}px`
  }" />
  <section
    v-if="showSideNav && currentNavList.length > 0"
    :style="`width:${sideBarWidth}px`"
    class="side-bar"
  >
    <layout-sub-nav :sub-nav-list="currentNavList" />
  </section>

  <section class="content-wrapper">
    <router-view />
  </section>
  <layout-modify-password />
</section>
</template>

<script>
import LayoutHeader from './Header'
import * as EventKeyMap from './EventKeys'
import LayoutModifyPassword from './ModifyPassword'
import LayoutSubNav from './SubNav'
import BaseStore from '../BaseStore'

export default {
  name: 'LayoutMain',
  extends: BaseStore,
  components: {LayoutSubNav, LayoutModifyPassword, LayoutHeader},
  computed: {
    currentNavList () {
      let {$route: {matched}} = this

      let mainRoutePath = matched[1]
      let name = mainRoutePath.name
      let currentRoute = this.navList.find(nav => nav.name === name)

      if (currentRoute) {
        let {children} = currentRoute

        if (Array.isArray(children)) {
          return children
        }
      }

      return []
    },
    sideBarWidth () {
      return -this.showSideNav & (-this.currentNavList.length >> -1) & 180
    }
  },
  methods: {
    onWrapperMouseDown (event) {
      this.target = event.target
    },
    onWrapperMouseUp (event) {
      if (event.target === this.target) {
        this.$eventBus.emit(EventKeyMap.WRAPPER_CLICK, event)
      }
    }
  },
  beforeDestroy () {
    this.target = null
  }
}
</script>

<style lang="scss" scoped>
.layout-main {
  $HEADER-HEIGHT: 78px;

  padding: $HEADER-HEIGHT 0 0;
  /*background-color: #F7F7F7;*/
  background-color: #161E43;

  > .layout-header {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: $HEADER-HEIGHT;
  }

  > .side-bar {
    position: absolute;
    font-size: .875rem;
    top: $HEADER-HEIGHT;
    bottom: 0;
    left: 0;
    /*border-right: 1px solid #e6e6e6;*/
    /*background-color: #222d32;*/
    /*background-color: #ffffff;*/
    /*color: #303133;*/
    color: #5B92FF;
    overflow: auto;
    user-select: none;
  }

  > .content-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/index.vue